export const normalizeTitle = (title: string): string =>
  title.replace(/\r?\n/g, ' ').replace(/\s+/g, ' ').trim()

export const formatRank = (rank: number): string => String(rank).padStart(2, '0')

/** Compact units-sold label, e.g. 9 -> "9", 12400 -> "12.4k", 1500000 -> "1.5M". */
export const formatSoldCount = (count: number): string => {
  if (!Number.isFinite(count) || count <= 0) return '0'
  if (count < 1000) return String(Math.round(count))
  if (count < 1_000_000) return `${Math.round(count / 100) / 10}k`
  return `${Math.round(count / 100_000) / 10}M`
}

export const buildMobileTabLabel = (categoryName: string): string => {
  const withoutCarPrefix = categoryName.replace(/^Car\s+/i, '').trim()
  const slashIdx = withoutCarPrefix.indexOf('/')
  const head =
    slashIdx !== -1 ? withoutCarPrefix.slice(0, slashIdx).trim() : withoutCarPrefix

  const word = head.split(/\s+/)[0] ?? head
  return word.toUpperCase()
}
